module.exports = __webpack_public_path__ + "static/media/Reverend Lovejoy.563d4ebe.png";